import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import YukXatiHeader from "../../Components/YukXati/YukXatiHeader";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import { useNavigate, useParams } from "react-router-dom";
import { OneCustomer } from "../../Stores/Customers/OneCustomer";
import { Modal, Spin } from "antd";

export default function CustomerEdit({ setOpen, open }) {
  const { updateUser, fetchData } = OneCustomer();
  const messageApi = useMessage();
  let navigate = useNavigate();
  let { id } = useParams();
  let [customer, setCustomer] = useState(null);
  let [loading, setLoading] = useState(false);

  let getUser = async () => {
    try {
      setLoading(true);
      let { data: info } = await axiosInstance.get("/api/customers/" + id);

      console.log(info?.data);
      setCustomer(info?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchData(id);
    getUser();
  }, [open]);

  return (
    <Modal
      style={{ top: "40px", width: "900px" }}
      title="O'zgartirish"
      open={open}
      width={800}
      //   loading={loadVagon}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpen(false);
      }}
      footer={[]}
    >
      <div>
        <div className=" flex flex-col m-auto justify-center">
          {/* <h1 className="text-2xl text-center m-0 p-0">O'zgartirish</h1> */}

          {customer?.name && !loading ? (
            <Formik
              initialValues={{
                name: customer?.name,
                comment: customer?.comment,
                phone: customer?.phone,
                type: customer?.type,
                INN: customer?.INN,
              }}
              validationSchema={Yup.object({
                name: Yup.string().required("Yozish shart"),
                INN: Yup.string(),
                type: Yup.string().required("Yozish shart"),
                comment: Yup.string().required("Yozish shart"),
                phone: Yup.string()
                  .min(9, "Raqam xato yozildi")
                  .max(9, "Raqam xato yozildi")
                  .required("Yozish shart shart "),
              })}
              onSubmit={(values) => {
                // console.log(values);
                updateUser(id, values);
                setOpen(false);
              }}
            >
              <Form>
                <label htmlFor="INN">INN</label>
                <Field
                  className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  name="INN"
                  type="Number"
                />
                <div className="mt-1 text-sm text-red-600">
                  <ErrorMessage name="INN" />
                </div>

                <label htmlFor="name">Nomi</label>
                <Field
                  className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  name="name"
                  type="text"
                />
                <div className="mt-1 text-sm text-red-600">
                  <ErrorMessage name="name" />
                </div>

                <label htmlFor="phone">Tel raqam</label>
                <Field
                  className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  name="phone"
                  type="number"
                />
                <div className="mt-1 text-sm text-red-600">
                  <ErrorMessage name="phone" />
                </div>

                {/* type */}
                <label htmlFor="type">Turi</label>
                <Field
                  id="type"
                  name="type"
                  component="select"
                  className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  as="select"
                >
                  <option value="">Tanlang</option>
                  <option value="MCHJ / FX">MCHJ / FX</option>
                  <option value="Brokker">Brokker</option>
                  <option value="Shaxs">Shaxs</option>
                  <option value="Muhammadjon aka">Muhammadjon aka</option>
                  <option value="Do'kon">Do'kon</option>
                  <option value="Shaxobcha">Shaxobcha</option>
                  <option value="Ombor">Ombor</option>
                </Field>
                <div className="mt-1 text-sm text-red-600">
                  <ErrorMessage name="type" />
                </div>

                {/* comment */}
                <label htmlFor="comment">Izox</label>
                <Field
                  className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  name="comment"
                  as="textarea"
                  rows="4"
                />
                <div className="mt-1 text-sm text-red-600">
                  <ErrorMessage name="comment" />
                </div>

                <br />
                <button
                  type="submit"
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2  rounded block w-full"
                >
                  Saqlash
                </button>
              </Form>
            </Formik>
          ) : (
            <div className="flex flex-row items-center justify-center pt-[40px] w-[100%]">
              <Spin size="large" />
            </div>
          )}
        </div>
      </div>{" "}
    </Modal>
  );
}
